module.exports = __webpack_public_path__ + "img/IT.eb399c2c.png";